
// @ts-nocheck


export const localeCodes =  [
  "en",
  "et"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46js_10b7a94d",
      load: () => import("#nuxt-i18n/10b7a94d" /* webpackChunkName: "locale_en_46js_10b7a94d" */),
      cache: true
    }
  ],
  et: [
    {
      key: "locale_et_46js_37892e5f",
      load: () => import("#nuxt-i18n/37892e5f" /* webpackChunkName: "locale_et_46js_37892e5f" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "et-US",
      name: "English",
      files: [
        {
          path: "/code/i18n/lang/en.js",
          cache: undefined
        }
      ]
    },
    {
      code: "et",
      language: "et-EE",
      name: "Eesti",
      files: [
        {
          path: "/code/i18n/lang/et.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "et",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_and_default",
  lazy: true,
  langDir: "lang/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirect",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "no prefix",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://geoloogia.info",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "et-US",
    name: "English",
    files: [
      {
        path: "/code/i18n/lang/en.js",
        cache: undefined
      }
    ]
  },
  {
    code: "et",
    language: "et-EE",
    name: "Eesti",
    files: [
      {
        path: "/code/i18n/lang/et.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/